// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"e0420d2b","456":"70bdcef9","656":"2ca3446c","756":"3a0988cb","787":"c442eb25","968":"283db38e"}[chunkId] + ".chunk.js";
};